import { useStores } from "@/stores";
import type { UserStoreInstance } from "@/stores/UserStore";

/**
 * Access the MST UserStore from React components.
 * Components consuming observable values should be wrapped with `observer` from mobx-react-lite.
 */
export function useUserStore(): UserStoreInstance {
  const root = useStores();
  return root.userStore;
}
